import { CHIPS_COLORS } from './colors';
import { ChipType } from '../types';

export const CHIPS_MIN_2: ChipType[] = [
  {
    color: CHIPS_COLORS.BROWN,
    value: 0.5,
  },
  {
    color: CHIPS_COLORS.BLUE,
    value: 2,
  },
  {
    color: CHIPS_COLORS.YELLOW,
    value: 5,
  },
  {
    color: CHIPS_COLORS.RED,
    value: 10,
  },
  {
    color: CHIPS_COLORS.VIOLET,
    value: 20,
  },
  {
    color: CHIPS_COLORS.GREEN,
    value: 50,
  },
  {
    color: CHIPS_COLORS.ORANGE,
    value: 100,
  },
  {
    color: CHIPS_COLORS.LIGHT_BLUE,
    value: 500,
  },
  {
    color: CHIPS_COLORS.SCARLET,
    value: 1e3,
  },
  {
    color: CHIPS_COLORS.PURPLE,
    value: 2e3,
  },
  {
    color: CHIPS_COLORS.LIGHT_GREEN,
    value: 5e3,
  },
  {
    color: CHIPS_COLORS.PINK,
    value: 10e3,
  },
];
